import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import useRealVh from "./hooks/useRealVh";

import ROUTES from "./configs/routes";

import s from "./App.module.scss";

function App() {
  useRealVh();

  const routes = ROUTES.map(({ path, component, exact }) => {
    return <Route key={path} path={path} element={component} exact={exact} />;
  });

  return (
    <div className={s.root}>
      <Router>
        <Routes>{routes}</Routes>
      </Router>
    </div>
  );
}

export default App;
